import { graphql } from 'generated/gql/account-manager';

export const currentUserQueryDocument = graphql(`
  query currentUser($wordpressUserId: Int!) {
    user(wordpressUserId: $wordpressUserId) {
      id
      activeAccount {
        id
        owner {
          name
          carrotAccountStatus
          carrotCrmConfig {
            id
            teamId
          }
        }
      }
      account {
        id
      }
      accounts {
        id
        name
        isAgency
      }
      carrotAccountStatus
      carrotVersion
      dashboardOptInState
      name
      email
      createdAt
      wordpressUserId
      wordpressUsername
      superAdmin
      vip
      currentSubscription {
        status
        canceledAt
        pastDueDate
        pastDueCancelAtDate
        pendingCancellation
        discount {
          endDate
          startDate
          coupon {
            name
            duration
            percentOff
            amountOff
          }
        }
        starter {
          id
          active
          customerType
          interval
          wordpressLabel
          version
          product {
            name
            starter
            group
          }
        }
        items {
          quantity
          price {
            id
            active
            amount
            wordpressLabel
            version
            product {
              name
              starter
            }
          }
        }
      }
    }
  }
`);
